import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="relative py-16 md:py-24 bg-foreground-900">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left - Text */}
          <div>
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100/90 text-accent-800 mb-6 whitespace-nowrap">
              About Kakobuy Spreadsheet
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight">
              The Most <span className="italic text-primary-300">Trusted Resource</span> for Smart Shoppers
            </h2>
            <p className="mt-5 text-sm md:text-base text-background-200 leading-relaxed">
              <strong className="text-background-50 font-semibold">Kakobuy Spreadsheet</strong> was created to solve one problem: finding quality products across countless sellers is time-consuming and overwhelming. Our spreadsheet directory consolidates thousands of verified product links into organized, easy-to-navigate categories — saving you hours of searching.
            </p>
            <p className="mt-4 text-sm md:text-base text-background-300 leading-relaxed">
              Whether you are looking for the <strong className="text-background-100">best Kakobuy Spreadsheet</strong> for shoes, clothing, bags, or accessories, our resource center provides daily-updated links, buying guides, and safety tips that make cross-border shopping straightforward and secure.
            </p>
            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer w-fit"
              >
                <i className="ri-file-list-3-line"></i>
                Open Spreadsheet Now
              </a>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-300 text-background-200 font-semibold text-sm hover:border-background-100 hover:text-background-50 transition-all whitespace-nowrap cursor-pointer w-fit"
              >
                Learn More About Us
              </Link>
            </div>
          </div>

          {/* Right - Stats card */}
          <div className="bg-background-100/10 backdrop-blur-sm rounded-2xl p-8 md:p-10 border border-background-200/20">
            <div className="text-center md:text-left">
              <div className="text-5xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50">500+</div>
              <p className="mt-2 text-sm md:text-base text-background-300">Updated spreadsheets curated and verified</p>
            </div>
            <div className="mt-8 space-y-5">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/20 text-accent-300 shrink-0">
                  <i className="ri-check-double-line text-lg"></i>
                </div>
                <div>
                  <p className="text-background-50 font-semibold text-sm md:text-base">Double-Verified Links</p>
                  <p className="text-background-400 text-xs md:text-sm mt-0.5">Every entry checked by our team</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/20 text-primary-300 shrink-0">
                  <i className="ri-time-line text-lg"></i>
                </div>
                <div>
                  <p className="text-background-50 font-semibold text-sm md:text-base">Daily Refreshed</p>
                  <p className="text-background-400 text-xs md:text-sm mt-0.5">New links added every 24 hours</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-500/20 text-secondary-300 shrink-0">
                  <i className="ri-shield-star-line text-lg"></i>
                </div>
                <div>
                  <p className="text-background-50 font-semibold text-sm md:text-base">Safety First</p>
                  <p className="text-background-400 text-xs md:text-sm mt-0.5">Shopping tips and scam prevention guides</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}